import { render, staticRenderFns } from "./DepotInfoItem.vue?vue&type=template&id=d5e00b3a"
import script from "./DepotInfoItem.vue?vue&type=script&lang=js"
export * from "./DepotInfoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports